import React, { useState } from "react";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import { usePortalAuth } from "../../auth/PortalAuthContext";

export default function PortalLogin() {
  const { account, login, loading } = usePortalAuth();
  const navigate = useNavigate();
  const location = useLocation() as { state?: { from?: Location } };
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  if (!loading && account) {
    const dest = (location.state?.from as unknown as { pathname?: string })?.pathname ?? "/portal";
    return <Navigate to={dest} replace />;
  }

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      await login(email, password);
      navigate("/portal");
    } catch {
      setError("E-mail ou senha inválidos.");
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="d-flex align-items-center justify-content-center vh-100">
      <form
        onSubmit={handleSubmit}
        className="d-flex flex-column gap-3 p-4"
        style={{
          width: "min(360px, 90vw)",
          background: "var(--color-surface)",
          borderRadius: "var(--radius-lg)",
          boxShadow: "var(--shadow-lg)",
        }}
      >
        <div>
          <div
            className="d-flex align-items-center justify-content-center mb-3"
            style={{ width: 36, height: 36, borderRadius: 8, background: "var(--sp-navbar)" }}
          >
            <span style={{ fontSize: 15, fontWeight: 700, color: "#fff" }}>SP</span>
          </div>
          <h4 className="mb-1" style={{ fontWeight: 400 }}>
            Portal do cliente
          </h4>
          <p className="text-secondary mb-0" style={{ fontSize: 13 }}>
            Acompanhe seus títulos e a situação da sua assinatura.
          </p>
        </div>

        <div className="field">
          <label htmlFor="email" className="form-label" style={{ fontSize: 12 }}>
            E-mail
          </label>
          <input
            id="email"
            type="email"
            className="form-control"
            autoComplete="username"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        <div className="field">
          <label htmlFor="password" className="form-label" style={{ fontSize: 12 }}>
            Senha
          </label>
          <input
            id="password"
            type="password"
            className="form-control"
            autoComplete="current-password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>

        {error && (
          <div className="text-danger" style={{ fontSize: 12.5 }}>
            {error}
          </div>
        )}

        <button type="submit" className="btn btn-primary btn-block" disabled={submitting}>
          {submitting ? "Entrando…" : "Entrar"}
        </button>
        <Link to="/portal/esqueci-senha" style={{ fontSize: 12.5, textAlign: "center", color: "var(--color-neutral-400)" }}>
          Esqueci minha senha
        </Link>
      </form>
    </div>
  );
}
